"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.feedbackNotificationClasses = exports.default = void 0;
exports.getFeedbackNotificationUtilityClass = getFeedbackNotificationUtilityClass;
var _base = require("@ori-ui/mui-bundle/base");
function getFeedbackNotificationUtilityClass(slot) {
  return (0, _base.generateUtilityClass)('MuiOriFeedbackNotification', slot);
}
const feedbackNotificationClasses = exports.feedbackNotificationClasses = (0, _base.generateUtilityClasses)('MuiOriFeedbackNotification', ['root', 'icon', 'notification', 'message', 'colorError', 'colorSuccess', 'colorWarning', 'colorInitial']);
var _default = exports.default = feedbackNotificationClasses;
